module.exports = __webpack_public_path__ + "img/UserImg.2c18d5e4.png";